<template>
  <div class='main'>
    <Button @click="roleBtn(msg,roleItem)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-model="modal1"
      footer-hide
      :draggable="true"
    >
      <p slot="header">
        <span>{{msg}}角色</span>
      </p>
      <el-form
        :model="roleForm"
        :rules="rules"
        ref="roleForm"
        label-width="100px"
        class="demo-roleForm"
      >
        <el-form-item
          label="编号"
          prop="rolecode"
        >
          <el-input v-model="roleForm.rolecode"></el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="rolename"
        >
          <el-input v-model="roleForm.rolename"></el-input>
        </el-form-item>
        <el-form-item
          label="角色类型"
          prop="roletype"
        >
          <el-select
            v-model="roleForm.roletype"
            placeholder="请选择角色类型"
          >
            <el-option
              label="中心管理员"
              value="1"
            ></el-option>
            <el-option
              label="系管理员"
              value="2"
            ></el-option>
            <el-option
              label="专业管理员"
              value="3"
            ></el-option>
            <el-option
              label="院校管理员"
              value="4"
            ></el-option>
            <el-option
              label="教师"
              value="5"
            ></el-option>
            <el-option
              label="学生"
              value="6"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            v-model="roleForm.description"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('roleForm')"
          >立即创建</el-button>
          <el-button @click="resetForm('roleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script>
import Api from '../../api/index'
export default {
  data () {
    return {
      modal1: false,
      roleForm: {
        rolecode: '',
        rolename: '',
        roletype: '',
        schoolId: '0d4bc22d669f48a6aa7d18df4872cea9',
        description: ''
      },
      rules: {
        rolecode: [
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        rolename: [
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        roletype: [
          { required: true, message: '请选择角色类型', trigger: 'change' }
        ],

      },
    }
  },
  props: {
    msg: String,
    icon: String,
    roleItem: Object,
  },
  created () {
    this.GetDataList()

  },
  methods: {
    //获取角色列表
    async GetDataList () {
      const res = await Api.role.GetDataList(this.currentpage, this.pagesize)
      if (!res.success) return this.$Message.error('获取角色列表失败!')
      this.roleDataList = res.rows;
      this.$emit('roleDataList', res.rows)
    },
    //角色管理按钮
    async roleBtn (msg) {
      if (msg == '编辑' && JSON.stringify(this.roleItem) == '{}') {
        return this.$Message.info('请选择需要编辑的角色！')
      } else if (msg == '编辑') {
        const res = await Api.role.GetDataById(this.roleItem.roleid)
        if (res.success != true) return this.Message(res.msg)
        this.roleForm = res.rows
      }
      this.modal1 = true;
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await Api.role.SaveData(this.roleForm)
          if (!res.success) return this.$Message.error('添加失败!')
          this.GetDataList();
          this.$refs[formName].resetFields();
          if (res.success) this.modal1 = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },

  }
}
</script>
<style lang='less' scoped>
</style>